import appActions from '../containers/App/actions';
import appConstants from '../containers/App/constants';

import dashboardActions from '../containers/Dashboard/actions';
import dashboardConstants from '../containers/Dashboard/constants';

import dashboardMassUploadActions from '../containers/DashboardMassUpload/actions';
import dashboardMassUploadConstants from '../containers/DashboardMassUpload/constants';

import loginPageActions from '../containers/LoginPage/actions';
import loginPageConstants from '../containers/LoginPage/constants';

import techniciansReportFormActions from '../containers/TechniciansReportForm/actions';
import techniciansReportFormConstants from '../containers/TechniciansReportForm/constants';

import topNavbarActions from '../containers/TopNavbar/actions';
import topNavbarConstants from '../containers/TopNavbar/constants';

export default {
  app: {
    actions: appActions,
    constants: appConstants
  },
  dashboard: {
    actions: dashboardActions,
    constants: dashboardConstants
  },
  dashboardMassUpload: {
    actions: dashboardMassUploadActions,
    constants: dashboardMassUploadConstants
  },
  loginPage: {
    actions: loginPageActions,
    constants: loginPageConstants
  },
  techniciansReportForm: {
    actions: techniciansReportFormActions,
    constants: techniciansReportFormConstants
  },
  topNavbar: {
    actions: topNavbarActions,
    constants: topNavbarConstants
  }
};



// WEBPACK FOOTER //
// ./src/shared/actionsAndConstants.js